import { initializeTable } from '../tables';
import RowContextMenuButtonColumn from '../formatters/RowContextMenuButtonColumn';
import { deletePrompt } from '../../prompts';
import { addAlert } from '../../alerts';
import { initializeDependentGroupTypeSelects } from '../../utils';

export default function initializeGlobalComponentsTable({ ...options }) {
    const tableElement = document.getElementById('globalComponentsTable');
    if (!tableElement) return;

    const filtersElement = document.querySelector(
        '#globalComponentsFilters .form-fields',
    );

    const deviceGroup = filtersElement.querySelector('#id_device_group');
    const deviceType = filtersElement.querySelector('#id_device_type');
    initializeDependentGroupTypeSelects(deviceGroup, deviceType);

    const ajaxURL = tableElement.dataset.ajaxUrl;

    const table = initializeTable({
        tableElement: tableElement,
        filtersElement: filtersElement,
        ajaxURL: ajaxURL,
        columns: [
            { title: 'ID', field: 'id', visible: false },
            { title: '#', formatter: 'rownum', width: 60, headerSort: false },
            {
                title: gettext('Nazwa'),
                field: 'name',
                headerSort: true,
            },
            {
                title: gettext('Cel'),
                field: 'target_quantity',
                headerSort: true,
            },
            {
                title: gettext('Grupa urządzenia'),
                field: 'device_group',
                formatter: (cell) => {
                    const val = cell.getValue();
                    const tableEl = document.getElementById(
                        'globalComponentsTable',
                    );
                    if (!tableEl) return val;
                    const groups = JSON.parse(
                        tableEl.dataset.deviceGroups || '[]',
                    );
                    const group = groups.find((g) => g.id === val);
                    return group ? group.value : val;
                },
            },
            {
                title: gettext('Typ urządzenia'),
                field: 'device_type',
                formatter: (cell) => {
                    const val = cell.getValue();
                    const tableEl = document.getElementById(
                        'globalComponentsTable',
                    );
                    if (!tableEl) return val;
                    const types = JSON.parse(
                        tableEl.dataset.deviceTypes || '[]',
                    );
                    const type = types.find((t) => t.id === val);
                    return type ? type.value : val;
                },
            },
            {
                title: gettext('Producent'),
                field: 'device_manufacturer',
                formatter: (cell) => {
                    const val = cell.getValue();
                    const tableEl = document.getElementById(
                        'globalComponentsTable',
                    );
                    if (!tableEl) return val;
                    const manufacturers = JSON.parse(
                        tableEl.dataset.deviceManufacturers || '[]',
                    );
                    const manufacturer = manufacturers.find(
                        (m) => m.id === val,
                    );
                    return manufacturer ? manufacturer.value : val;
                },
            },
            {
                title: gettext('Modele'),
                field: 'device_models',
                headerSort: false,
            },
            {
                title: gettext('Akcje'),
                formatter: RowContextMenuButtonColumn,
                width: 100,
                resizable: false,
                headerSort: false,
                hozAlign: 'center',
            },
        ],
        rowContextMenu: [
            {
                label: gettext('Edytuj'),
                action: (e, row) => {
                    const rowData = row.getData();
                    if (window.globalComponentPopup) {
                        window.globalComponentPopup.openInEditMode(rowData.id);
                    }
                },
            },
            {
                label: gettext('Duplikuj'),
                action: (e, row) => {
                    const rowData = row.getData();
                    if (window.globalComponentPopup) {
                        window.globalComponentPopup.openInDuplicateMode(
                            rowData.id,
                        );
                    }
                },
            },
            {
                label: gettext('Usuń'),
                action: (e, row) => {
                    const rowData = row.getData();
                    deletePrompt({
                        options: {
                            title: gettext('Potwierdzenie'),
                            html: gettext(
                                'Czy na pewno chcesz usunąć ten element?',
                            ),
                        },
                        url: `${ajaxURL}/${rowData.id}`,
                        successAction: () => {
                            row.delete();
                            addAlert('success', gettext('Element usunięty.'));
                        },
                        failedAction: (err) => {
                            addAlert(
                                'error',
                                gettext('Błąd podczas usuwania.'),
                            );
                        },
                    });
                },
            },
        ],
        layout: 'fitColumns',
        dataMode: 'remote',
        pillsConfig: {
            containerSelector: '.active-filters-container',
            ignoreFields: [],
        },
        ...options,
    });

    document.addEventListener('globalComponentUpdated', () => {
        if (table) {
            table.replaceData();
        }
    });

    return table;
}
